import Image from "next/image";
import Oestra from "@/icons/products/product-oestra-r-colored-label.svg";
import Paragraph from "~/componentsDS/Typography/Paragraph";

const ComparisonOestraCard = () => (
    <div className="py-[10px] md:py-0">
        <div className="relative pt-8 pb-10 h-[500px] md:h-[550px] shadow-[1px_1px_9.2px_0_rgba(0,0,0,0.25)] rounded-2xl overflow-hidden">
            <Image
                src="https://res.cloudinary.com/dirscuuhp/image/upload/v1775406222/new_design/Frame_2087327989_1_hcoowf.webp"
                alt="Oestra"
                fill
                sizes="(max-width: 767px) 0px, 70vw"
                className="hidden md:block object-cover object-center"
            />

            <Image
                src="https://res.cloudinary.com/dirscuuhp/image/upload/v1775637074/new_design/Frame_2087329548_1_eque6l.webp"
                alt="Oestra"
                fill
                sizes="(max-width: 767px) 100vw, 0px"
                className="md:hidden object-cover object-center"
            />

            <div className="relative h-full flex flex-col items-center">
                <Oestra className="w-[184px] h-auto mb-6"/>
                <Paragraph className="text-[18px] md:text-[26.5px] text-medium md:text-light leading-[1.3] md:leading-[1.1] tracking-[-0.01em] text-center text-pureWhite md:text-primary500 max-md:mt-auto">
                    Oestra<sup>®</sup> replaces the patchwork with <br />
                    one steady formula designed for <br />
                    <i className="max-md:not-italic md:font-featureDisplay md:text-[23px] md:font-normal">systemic</i> absorption and <i className="max-md:not-italic md:font-featureDisplay md:text-[23px] md:font-normal">balanced</i> dosing.
                </Paragraph>
                <Paragraph size="md" sizes={{ md: "lg" }} className="text-center text-pureWhite mt-[10px] md:mt-auto">
                    One formula. <br className="md:hidden" />One routine. <br className="md:hidden" />One price.
                    <span className="hidden md:block">That rhythm matters.</span>
                </Paragraph>
            </div>
        </div>
    </div>
);

export default ComparisonOestraCard;
